import { TabList, TabPanel } from "@mui/lab"
import { styled, Paper, Box, Tab } from "@mui/material"

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}))

export const DashboardWrapper = styled(Box)({
  display: "flex",
  backgroundColor: "#F8F9FA",
  // border: "1px solid red",
  height: "90vh",
})

export const DashboardPaper = styled(Paper)({
  // border: "1px solid red",
  margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  // height: "90vh",
  // backgroundColor: "#f7f7f7",
  // padding: "20px"
  height: "78vh",
})

export const AgendaContainer = styled(Box)({
  flex: 1,
  margin: "10vh 24px 2vh 0",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  backgroundColor: "#FFFFFF",
  height: "78vh",
})

export const AgendaHeader = styled(Box)({
  height: "8vh",
  borderBottom: "1px solid #EFF0F5",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 15px",
})

export const AgendaMain = styled(Box)({
  // border: "1px solid red",
  height: "62vh",
  overflowY: "auto",
})

export const AgendaCardContainer = styled(Box)({
  // border: "1px solid red",
  padding: "18px 0 18px 18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #EFF0F5",
})

export const StyledTabPanel = styled(TabPanel)({
  padding: "0",
})

export const StyledTabList = styled(TabList)({
  height: "8vh",
  color: "#706F70",
  // marginLeft: "10px",
  width: "100%",
  ".MuiTab-root": {
    color: "#706F70",
    textTransform: "capitalize",
    fontSize: "12px",
    fontFamily: "Poppins",
    alignItems: "center",
    padding: 0,
  },
  // ".MuiTab-root.Mui-selected": {
  //   color: "#000000",
  // },
  // ".MuiTabs-indicator": {
  //   // backgroundColor: "#3C77EF",
  //   // maxWidth: "34px",
  //   height: "4px",
  // },
})

export const StyledTab = styled(Tab)({
  flex: 1,
})
